var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "userlayout space_between full_layout",
      attrs: { id: "userlayout" }
    },
    [
      _c("div", { staticClass: "userLeft" }, [
        _c("div", { staticClass: "userhead" }, [
          _c("span", { class: _vm.reversedLevel }, [
            _c("img", {
              attrs: {
                src: require("../../../static/images/userHeadPortrait.svg")
              }
            })
          ]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.userInfo.NickName))])
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "userMenu" }, [
          _c(
            "li",
            {
              class: { on: _vm.isWhat[0] == "user" && _vm.isWhat[1] == "info" }
            },
            [
              _c("router-link", { attrs: { to: { path: "/user/info" } } }, [
                _vm._v(_vm._s(_vm.$t("AccountInfo")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { on: _vm.isWhat[0] == "user" && _vm.isWhat[1] == "order" }
            },
            [
              _c("router-link", { attrs: { to: { path: "/user/order" } } }, [
                _vm._v(_vm._s(_vm.$t("OrderHistory")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: {
                on: _vm.isWhat[0] == "user" && _vm.isWhat[1] == "address"
              }
            },
            [
              _c("router-link", { attrs: { to: { path: "/user/address" } } }, [
                _vm._v(_vm._s(_vm.$t("ShippingAddresses")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("router-link", { attrs: { to: { path: "/cart" } } }, [
                _vm._v(_vm._s(_vm.$t("ShoppingCart")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { on: _vm.isWhat[0] == "user" && _vm.isWhat[1] == "point" }
            },
            [
              _c("router-link", { attrs: { to: { path: "/user/point" } } }, [
                _vm._v(_vm._s(_vm.$t("Points")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: {
                on: _vm.isWhat[0] == "user" && _vm.isWhat[1] == "exchange"
              }
            },
            [
              _c("router-link", { attrs: { to: { path: "/user/exchange" } } }, [
                _vm._v(_vm._s(_vm.$t("TradeCards")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("li", { on: { click: _vm.logout } }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("SignOut")))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("router-view", { on: { updata: _vm.updata } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c67c625", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c67c625","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/userlayout.vue
// module id = null
// module chunks = 